import React from 'react';
import { Space, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../hooks/useTranslation';

const { Text } = Typography;

export interface CompletedQuickActionsProps {
  appointment: {
    id: string;
    status: string;
  };
}

const CompletedQuickActions: React.FC<CompletedQuickActionsProps> = ({
  appointment
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div style={{ 
        textAlign: 'center', 
        padding: '16px',
        backgroundColor: '#f6ffed',
        border: '1px solid #b7eb8f',
        borderRadius: '6px'
      }}>
        <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a', marginBottom: '8px' }} />
        <div>
          <Text strong style={{ color: '#52c41a' }}>
            {t('appointments.completed') || 'Appointment Completed'}
          </Text>
        </div>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {t('appointments.noActionsAvailable') || 'No actions available'}
        </Text>
      </div>
    </Space>
  );
};

export default CompletedQuickActions;
